module.exports = __webpack_public_path__ + "static/media/tokenoverview-image.b06b1aa7.webp";